import { useCallback, useContext } from 'react';
import { ProductContext } from './product-context';
import { GoodTypes } from '../../interfaces/MerchantInfo';

export const useProduct = () => {
  const { product, setProduct, amount, setAmount } = useContext(ProductContext);

  const createProduct = useCallback(
    (
      newProduct: GoodTypes | null | undefined,
      newAmount: number | null
    ): void => {
      setProduct(newProduct);
      setAmount(newAmount);
    },
    [setAmount, setProduct]
  );

  const deleteProduct = useCallback((): void => {
    setProduct(null);
    setAmount(null);
  }, [setAmount, setProduct]);

  return {
    product,
    createProduct,
    amount,
    deleteProduct,
  };
};
